import type { PoiKind } from "../types";
import type { RouteContext } from "../routing";
import type { ParsedPoi } from "./types";
import { parsePoiResults } from "./parse";
export { parsePoiResults };

/**
 * Build the Overpass QL query string for POI search.
 * Searches both nodes and ways.
 *
 * @param polyStr         Closed polygon string for the Overpass poly: filter
 * @param includeToilets  Include toilet queries (both node and way)
 */
export function buildOverpassQuery(polyStr: string, includeToilets: boolean): string {
  const toiletLines = includeToilets
    ? `  node["amenity"="toilets"](poly:"${polyStr}");
  way["amenity"="toilets"](poly:"${polyStr}");`
    : "";

  return `[out:json][timeout:30];
(
  node["amenity"="fuel"](poly:"${polyStr}");
  node["amenity"="fuel"]["operator"~"[Oo]rlen"](poly:"${polyStr}");
  node["amenity"="fuel"]["brand"~"[Oo]rlen"](poly:"${polyStr}");
  node["amenity"="fuel"]["name"~"[Oo]rlen"](poly:"${polyStr}");
  way["amenity"="fuel"](poly:"${polyStr}");
  way["amenity"="fuel"]["operator"~"[Oo]rlen"](poly:"${polyStr}");
  way["amenity"="fuel"]["brand"~"[Oo]rlen"](poly:"${polyStr}");
  way["amenity"="fuel"]["name"~"[Oo]rlen"](poly:"${polyStr}");
  node["name"~"[Mm]c[Dd]onald"](poly:"${polyStr}");
${toiletLines}
);
out center qt;`;
}
